// src/services/api/dashboard.service.ts
import { authService } from '../auth.service';
import { ReferralData, ReferralActivation } from "../../types/application.types";
import { getServerUrl } from '../../config/server.config';
interface DashboardData {
    totalBalance: number;
    fiatBalance: number;
    cryptoBalance: number;
    feesBalance: number;
    wallets: {
        currency: string;
        address: string;
        balance: string;
    }[];
}
interface ErrorResponse {
    success: false;
    message: string;
    error?: {
        code?: string;
        details?: string;
    };
}
interface TransferData {
    "amount": number,
    "originRailAccountId": string,
    "currency": string,
    "destinationEmail": string
}
interface WithDrawData {
    "amount": string,
    "originRailAccountId": string,
    "currency": string,
    "counterpartyId": string
}
interface FiatToCryptoSwap {
    "swapType": string,
    "originRailAccountId": string,
    "originCurrency": string,
    "destinationRailAccountId": string,
    "destinationCurrency": string,
    "amount": number,
}
interface ResponseInternalTransferData {
    data: any[],
    message: string,
    success: boolean
}
interface ResponseInternalWithdrawData {
    data: any[],
    message: string,
    success: boolean
}
interface ResponseFiatToCryptoData {
    data: any[],
    message: string,
    success: boolean
}
interface TopUpData {
    amount: number,
    railAccountId: string
}
interface ResponseTopUpData {
    success: boolean,
    message: string,
    data: any[];
}
class TransferService {
    private get baseUrl(): string {
        return getServerUrl(true);
    }

    async internalTransfer(data: TransferData): Promise<ResponseInternalTransferData> {
        try {
            const response = await fetch(`${this.baseUrl}/transfer-request/internal`, {
                method: 'POST',
                headers: {
                    'Authorization': authService.getAuthorizationHeader(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data), // Empty body; adjust if API requires specific data
            });

            return await response.json();
        } catch (error) {
            console.error('Error activating referrer:', error);
        }
    }
    async transferWithdraw(data: WithDrawData): Promise<ResponseInternalWithdrawData> {
        try {
            const response = await fetch(`${this.baseUrl}/transfer-request/withdrawal`, {
                method: 'POST',
                headers: {
                    'Authorization': authService.getAuthorizationHeader(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data), // Empty body; adjust if API requires specific data
            });

            return await response.json();
        } catch (error) {
            console.error('Error activating referrer:', error);
        }
    }
    async fiatToCryptoSwap(data: FiatToCryptoSwap): Promise<ResponseFiatToCryptoData> {
        try {
            const response = await fetch(`${this.baseUrl}/swap-request/request`, {
                method: 'POST',
                headers: {
                    'Authorization': authService.getAuthorizationHeader(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data), // Empty body; adjust if API requires specific data
            });

            return await response.json();
        } catch (error) {
            console.error('Error activating referrer:', error);
        }
    }
    async topUp(data: TopUpData): Promise<ResponseTopUpData> {
        try {
            const response = await fetch(`${this.baseUrl}/mastercard-reload/request`, {
                method: 'POST',
                headers: {
                    'Authorization': authService.getAuthorizationHeader(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data), // Empty body; adjust if API requires specific data
            });

            return await response.json();
        } catch (error) {
            console.error('Error activating referrer:', error);
        }
    }
}

export const transferService = new TransferService();